const env = 'env';
const production = 'production';
const host = 'host';
const prodHost = 'prodHost';
const clientHost = 'clientHost';
const apiUrl = 'apiUrl';
const oldUrl = 'oldUrl';
const redirectUrl = 'redirectUrl';
const oauthUrl = 'oauthUrl';
const appleRedirectUrl = 'appleRedirectUrl';
const appleClientId = 'appleClientId';
const osrmServiceUrl = 'osrmServiceUrl';
const safeOsrmServiceUrl = 'safeOsrmServiceUrl';
const osrmRouteUrl = 'osrmRouteUrl';
const photonServiceUrl = 'photonServiceUrl';
const photonReverseUrl = 'photonReverseUrl';
const showFacebookButton = 'showFacebookButton';
const projectName = 'projectName';
const projectFullName = 'projectFullName';
const contactEmail = 'contactEmail';
const termsOfUse = 'termsOfUse';
const privacyPolicy = 'privacyPolicy';
const termsOfUse_cat = 'termsOfUse_cat';
const privacyPolicy_cat = 'privacyPolicy_cat';
const termsOfUse_esp = 'termsOfUse_esp';
const privacyPolicy_esp = 'privacyPolicy_esp';
const termsOfUse_eng = 'termsOfUse_eng';
const privacyPolicy_eng = 'privacyPolicy_eng';
const termsOfUse_nld = 'termsOfUse_nld';
const privacyPolicy_nld = 'privacyPolicy_nld';
const supportedLanguages = 'supportedLanguages';
const showMobileAppOption = 'showMobileAppOption';
const showGettingStartedClips = 'showGettingStartedClips';
const smartPhoneReportSend = 'smartPhoneReportSend';
const exportReportToPpt = 'exportReportToPpt';
const publicMapSidebar = 'publicMapSidebar';
export const environment = {
  production: window[env][production] || false,
  host: window[env][host] || 'https://dev.route2school.be',
  prodHost: window[env][prodHost] || 'https://www.route2school.be',
  clientHost: window[env][clientHost] || 'https://dev.route2school.be/platform/',
  apiUrl: window[env][apiUrl] || 'https://dev.route2school.be/api2',
  oldUrl: window[env][oldUrl] || 'https://dev.route2school.be/legacy/login/r2s.html?locale=nl#!home',
  redirectUrl: window[env][redirectUrl] || 'https://dev.route2school.be/platform/oauth2/redirect',
  oauthUrl: window[env][oauthUrl] || 'https://dev.route2school.be/api2/oauth2/authorize/',
  osrmServiceUrl: window[env][osrmServiceUrl] || 'https://imobwww.uhasselt.be/osrm5/',
  safeOsrmServiceUrl: window[env][safeOsrmServiceUrl] || 'https://imobwww.uhasselt.be/osrm5/safe/',
  osrmRouteUrl: window[env][osrmRouteUrl] || 'https://imobwww.uhasselt.be/tools/osrm_demo/osrm/route/v1/driving/4.96479,51.157062;4.997406005859375,51.15275517715878?overview=false&alternatives=false&steps=true',
  photonServiceUrl: window[env][photonServiceUrl] || 'https://imobwww.uhasselt.be/photon/api',
  photonReverseUrl: window[env][photonReverseUrl] || 'https://imobwww.uhasselt.be/photon/reverse',
  appleRedirectUrl: window[env][appleRedirectUrl] || 'https://dev.route2school.be/api2/auth/callback/apple/website',
  appleClientId: window[env][appleClientId] || 'be.route2school.website',
  appleScope: 'name email',
  appleResponseType: 'code id_token',
  appleSignInUrl: 'https://appleid.apple.com/auth/authorize',
  tileURL: 'https://imobwww.uhasselt.be/osm_tiles2/{z}/{x}/{y}.png',
  maxZoom: 18,
  tileLayerDescription: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>',
  showFacebookButton: window[env][showFacebookButton]=="true",
  projectName: window[env][projectName] || 'R2S',
  projectFullName: window[env][projectFullName] || 'Route2School',
  contactEmail: window[env][contactEmail] || 'info@route2school.be',
  termsOfUse: window[env][termsOfUse] || 'https://www.route2school.be/gebruiksvoorwaarden/',
  privacyPolicy: window[env][privacyPolicy] || 'https://www.route2school.be/privacy-policy/',
  termsOfUse_cat: window[env][termsOfUse_cat] || window[env][termsOfUse] || 'https://www.route2school.be/gebruiksvoorwaarden/',
  privacyPolicy_cat: window[env][privacyPolicy_cat] || window[env][privacyPolicy] || 'https://www.route2school.be/privacy-policy/',
  termsOfUse_esp: window[env][termsOfUse_esp] || window[env][termsOfUse] || 'https://www.route2school.be/gebruiksvoorwaarden/',
  privacyPolicy_esp: window[env][privacyPolicy_esp] || window[env][privacyPolicy] || 'https://www.route2school.be/privacy-policy/',
  termsOfUse_eng: window[env][termsOfUse_eng] || window[env][termsOfUse] || 'https://www.route2school.be/gebruiksvoorwaarden/',
  privacyPolicy_eng: window[env][privacyPolicy_eng] || window[env][privacyPolicy] || 'https://www.route2school.be/privacy-policy/',
  termsOfUse_nld: window[env][termsOfUse_nld] || window[env][termsOfUse] || 'https://www.route2school.be/gebruiksvoorwaarden/',
  privacyPolicy_nld: window[env][privacyPolicy_nld] || window[env][privacyPolicy] || 'https://www.route2school.be/privacy-policy/',
  supportedLanguages: window[env][supportedLanguages],
  showMobileAppOption: window[env][showMobileAppOption]=="true",
  showGettingStartedClips: window[env][showGettingStartedClips]=="true",
  smartPhoneReportSend: window[env][smartPhoneReportSend]=="true",
  exportReportToPpt: window[env][exportReportToPpt]=="true",
  publicMapSidebar: window[env][publicMapSidebar]=="true"
};
